module.exports = __webpack_public_path__ + "static/media/card-logo-5.374ac105.svg";